import React from 'react';

import { FlyLoader } from '@fly/shared-ui';

const SilentRenewCallback = () => {
  return <FlyLoader />;
};

export default SilentRenewCallback;
